import { assetsConfig } from '../config/config.bundle';
import californiaProp from '../assets/images/certs/california-prop-65.jpg';
import logoOU from '../assets/images/certs/logo-ou.jpg';

export const SERVICES = [
  {
    code: 'M006',
    name: 'Dispose of Appliance  - Refrigeration',
  },
  {
    code: 'M007',
    name: 'Dispose of Appliance  - No Refrigeration',
  },
  {
    code: 'M101',
    name: 'Install Icemaker & Attach Water Line',
  },
  {
    code: 'M106',
    name: 'Supply Waterline & Attach to Refrigerator',
  },
  {
    code: 'M175',
    name: 'Install Refrigerator with Water Line',
  },
  {
    code: 'M170',
    name: 'Install Refrigerator without Water Line',
  },
  {
    code: 'M212',
    name: 'Install Hood and Hardwire',
  },
  {
    code: 'M227',
    name: 'Install Hood and Attach Power Cord',
  },
  {
    code: 'M402',
    name: 'Install Dishwasher and Supply Elbow',
  },
  {
    code: 'M435',
    name: 'Supply Dishwasher Water Supply Line',
  },
  {
    code: 'M270',
    name: 'Install Electric Range and Anti-Tip Bracket',
  },
  {
    code: 'M220',
    name: 'Supply and Install 3 or 4-Prong Range Cord',
  },
  {
    code: 'M260',
    name: 'Install Gas Range and Supply Flexible Gas Line',
  },
  {
    code: 'M302',
    name: 'Install Washer',
  },
  {
    code: 'M303',
    name: 'Install Electric Dryer',
  },
  {
    code: 'M320',
    name: 'Supply and Install 3 or 4-Prong Dryer Cord',
  },
  {
    code: 'M311',
    name: 'Install Gas Dryer and Attach Flexible Gas Line',
  },
  {
    code: 'M352',
    name: 'Install Electric Unitize Laundry Center',
  },
  {
    code: 'M353',
    name: 'Install Gas Unitized Laundry Center and Supply Gas Line',
  },
] as const;

export const deliveryMethodLocationTypeMap = {
  'SDS Delivery': 'sds_loc',
  'ADC Truckload': 'adc_loc',
  'ADC LTL': 'adc_loc',
  'ADC Box Truck': 'adc_loc',
  'SDS Will Call': 'sds_will_call_loc',
  'ADC Will Call': 'adc_will_call_loc',
  'SDS Delivery Next Day': 'sds_loc',
  'FedEx Ground': 'adc_loc',
  'ADC Velocity': 'adc_loc',
  'MATU Ocean Ocean Full Container': 'adc_loc',
  'Meet Truck': 'mt_loc',
} as const;

export type CertificationMeta = {
  label: string;
  imageUrl?: string;
  href?: string;
};

export const certifications: CertificationMeta[] = [
  {
    label: 'ENERGY STAR® Qualified',
    imageUrl: `${assetsConfig.geMigratedAssets}/images/common/logos/logo-energy_star.gif`,
  },
  {
    label: 'Produced In Our American Manufacturing Plants',
    imageUrl: `${assetsConfig.geMigratedAssets}/images/common/logos/logo-america_at_work.png`,
  },
  {
    label: 'ADA Compliant',
    imageUrl: `${assetsConfig.geMigratedAssets}/images/common/logos/logo-ada.gif`,
  },
  {
    label: 'California Prop 65',
    imageUrl: californiaProp,
    href: 'https://www.p65warnings.ca.gov/',
  },
  {
    label: 'OU Certified Sabbath Mode',
    imageUrl: logoOU,
  },
  {
    label: 'View Chemical Content Reports',
    href: 'https://www.geappliances.com/chemical-reports',
  },
];

export const DPM_CUSTOMER_CLASS_CODE = 'DIRECT PROPERTY MGT REPLACEMEN';

export const UNKNOWN_AVAILABILITY_VALUE = 10000000000;

export const AVAILABILITY_HORIZON = 175;
